import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Modal from 'components/ui/Modal';
import { ActionButton, ConfirmButton } from 'components/ui/Button';

import { StyledActionButton, ButtonWrapper } from '../CancelSpecificBookingItemsCta.styles';

const IsThirdPartyBookingCancellation = ({ isDisabled, isModalVisible, toggleModal, onSubmit, isLoading }) => (
  <>
    <StyledActionButton disabled={isDisabled} data-cy="cancel-refund" onClick={toggleModal} data-testid="cancel-button">
      <FormattedMessage id="manageBooking.cancelRefund" />
    </StyledActionButton>

    <Modal isOpen={isModalVisible} title={<FormattedMessage id="manageBooking.cancelRefundThirdParty" />} onClose={toggleModal}>
      <p>
        <FormattedMessage id="manageBooking.cancelRefundThirdPartyMessage" />
      </p>

      <ButtonWrapper>
        <ConfirmButton type="button" onClick={onSubmit} disabled={isLoading} data-testid="submit" variant="primary">
          <FormattedMessage id="refunds.confirmCancellation" />
        </ConfirmButton>

        <ActionButton onClick={toggleModal} data-testid="close">
          <FormattedMessage id="manageBooking.abandonCancellation" />
        </ActionButton>
      </ButtonWrapper>
    </Modal>
  </>
);

IsThirdPartyBookingCancellation.propTypes = {
  isModalVisible: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default IsThirdPartyBookingCancellation;
